import { useQuerySubscription } from "react-datocms"
import styles from "./blog-post.module.scss"
import { getAllRecords, getSubscription, queries } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import { datoModels } from "@data/static"
import AuthorBio from "@components/layouts/blog/AuthorBio/AuthorBio"
import FeaturedSuppliers from "@components/layouts/blog/FeaturedSuppliers/FeaturedSuppliers"
import PostAudio from "@components/layouts/blog/PostAudio/PostAudio"
import PostBody from "@components/layouts/blog/PostBody/PostBody"
import PostHeader from "@components/layouts/blog/PostHeader/PostHeader"
import PostsList from "@components/layouts/blog/PostsList/PostsList"
import ShareArticle from "@components/layouts/blog/ShareArticle/ShareArticle"
import Layout from "@components/structure/Layout/layout"
import Section from "@components/structure/Section/Section"
import Seo from "@components/structure/Seo/Seo"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

export async function getStaticPaths() {
  const { records } = await getAllRecords(datoModels.POST, null, null, true)
  return {
    paths: records.map((post) => `/top-tips/${post.slug}`),
    fallback: "blocking",
  }
}

export async function getStaticProps({ params }) {
  const graphqlRequest = {
    query: `
      query PostBySlug($slug: String) {
        ${queries.seo}
        blog(filter: {slug: {eq: $slug}}) {
          ${queries.innerBlog}
        }
        morePosts: allBlogs(orderBy: publishedDate_DESC, first: 3, filter: {slug: {neq: $slug}}) {
         ${queries.blog.query}
        }
      }
    `,
    variables: {
      slug: params.slug,
    },
  }

  const subscription = await getSubscription(graphqlRequest)
  const options = await loadOptionsData()

  return {
    props: {
      subscription,
      options,
    },
  }
}

export default function TopTipsPage({ subscription, options }) {
  const {
    data: { seo, blog, morePosts },
  } = useQuerySubscription(subscription)

  return (
    <Layout options={options}>
      <Seo global={seo} meta={blog?.seo} />
      <main className={styles.BlogPost}>
        <article>
          <PostHeader
            breadcrumbs
            title={blog.title}
            video={blog.video}
            featuredImage={blog.featuredImage}
            author={blog.author}
          />
          {blog.audioFile && <PostAudio audio={blog.audioFile.url} />}
          <PostBody body={blog.body} />
          {blog.featuredSuppliers && blog.featuredSuppliers.length ? (
            <FeaturedSuppliers suppliers={blog.featuredSuppliers} title={"Featured Suppliers"} />
          ) : null}
          {/* <div ref={shareArticleRef}> */}
          <ShareArticle url={blog.slug ? `houseofpartyplanning.com/top-tips/${blog.slug}` : ""} />
          {/* </div> */}
          <AuthorBio {...blog.author} />
        </article>
        <Section>
          <SiteWrapper>
            <PostsList posts={morePosts} title="You might also like" />
          </SiteWrapper>
        </Section>
      </main>
    </Layout>
  )
}
